import React, { Component } from 'react';

import i18n from 'i18n-react';
import PropTypes from 'prop-types';
import { ToastContainer, toast, cssTransition } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Zoom = cssTransition({
  enter: 'zoomIn',
  exit: 'zoomOut',
  duration: [500, 800],
});

export default class TrainingDials extends Component {
  constructor(props) {
    super(props);

    const { amountOfDials } = this.props;

    this.state = {
      selectedAnswerString: '',
      selectedAnswer: [],
      rotation: [],
    };
  }

  componentWillMount() {
    const { rotation, selectedAnswer } = this.state;
    const { amountOfDials } = this.props;
    let selectedAnswerString = amountOfDials === 3 ? '' : '0';
    for (let i = 0; i < amountOfDials; i += 1) {
      rotation.push(0);
      selectedAnswer.push(0);
      selectedAnswerString += 0;
    }
    this.setState({ rotation, selectedAnswer, selectedAnswerString });
  }

  updateDial(e) {
    e.preventDefault();
    const { id, children } = e.target;
    const { rotation, selectedAnswer } = this.state;

    if (e.type === 'click') {
      children[1].style.transform = `rotate(${rotation[id] += 36}deg)`;
      if (selectedAnswer[id] < 9) {
        selectedAnswer[id] += 1;
      } else {
        selectedAnswer[id] = 0;
      }
    }

    if (e.type === 'contextmenu') {
      children[1].style.transform = `rotate(${rotation[id] -= 36}deg)`;
      if (selectedAnswer[id] > 0) {
        selectedAnswer[id] -= 1;
      } else {
        selectedAnswer[id] = 9;
      }
    }

    let selectedAnswerString = '';
    selectedAnswer.forEach((answer) => {
      selectedAnswerString += answer;
    });
    if (selectedAnswerString.length === 2) {
      selectedAnswerString = `0${selectedAnswerString}`;
    }

    this.setState({ rotation, selectedAnswer, selectedAnswerString });
  }

  checkAnswers() {
    const { selectedAnswerString } = this.state;
    const {
      correctAnswer, contentComplete, incorrectAnswerText, correctAnswerText, error, amountOfDials,
    } = this.props;

    const isCorrect = amountOfDials === 3
      ? selectedAnswerString === correctAnswer
      : selectedAnswerString.slice(-2) === correctAnswer.slice(-2);

    if (isCorrect) {
      contentComplete();
      toast.success(correctAnswerText, {
        position: 'bottom-center',
        transition: Zoom,
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    } else {
      toast.error(incorrectAnswerText, {
        position: 'bottom-center',
        transition: Zoom,
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      error(true);
      error();
    }
  }

  renderDials(amount) {
    const dials = [];
    for (let i = 0; i < parseInt(amount, 10); i += 1) {
      const key = i;
      dials.push(<Dial number={this.state.selectedAnswer[key]} onClick={(e) => { this.updateDial(e); }} id={key} key={key} />);
    }
    return dials;
  }

  render() {
    const { amountOfDials, question, disableHeader } = this.props;
    return (
      <div className="container__question">
        {!disableHeader && <div className="container__question--image" />}
        <div className="container__question--content">
          <h4 className="container__title">{question}</h4>
          <div className="dials__wrapper">
            {this.renderDials(amountOfDials)}
          </div>
          <ToastContainer
            draggablePercent={70}
          />
          <button onClick={() => { this.checkAnswers(); }}>
            {i18n.translate('trainingScreens.confirm')}
          </button>
        </div>
      </div>
    );
  }
}

const Dial = props => (
  <div
    className="dial"
    id={props.id}
    tabIndex={-1}
    role="button"
    onClick={(e) => { props.onClick(e); }}
    onKeyPress={(e) => { props.onClick(e); }}
    onContextMenu={(e) => { props.onClick(e); }}
  >
    <div className="number" id={`number_${props.id}`}>
      {props.number}
    </div>
    {/* <img
      className="dial__image"
      src={`/${dial}`}
      alt="dial"
    /> */}
  </div>
);

TrainingDials.propTypes = {
  amountOfDials: PropTypes.number.isRequired,
  contentComplete: PropTypes.func.isRequired,
  correctAnswer: PropTypes.string.isRequired,
  correctAnswerText: PropTypes.string,
  disableHeader: PropTypes.bool,
  error: PropTypes.func,
  incorrectAnswerText: PropTypes.string,
  question: PropTypes.string.isRequired,
};

TrainingDials.defaultProps = {
  correctAnswerText: '',
  disableHeader: false,
  error: () => {},
  incorrectAnswerText: '',
};

Dial.propTypes = {
  id: PropTypes.number.isRequired,
  number: PropTypes.number.isRequired,
  onClick: PropTypes.func.isRequired,
};
